export interface State {
  benefits: []
  benefitDetil: {
    amount: number
    created_at: string
    description: string
    ended: boolean
    feature: string
    id: string
    name: string
    org: string
    profile_image: {
      id: string
      uploaded: boolean
      url: string
    }
    started: boolean
    updated_at: string
  } | null
  isBenefitsLoading: boolean
  hasUsed: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  benefits: [],
  benefitDetil: null,
  isBenefitsLoading: false,
  hasUsed: false
}

export const mutations: Mutations = {
  setBenefits(state, payload) {
    state.benefits = payload.benefits
  },
  clearBenefits(state) {
    state.benefits = []
  },
  setBenefitDetail(state, payload) {
    state.benefitDetil = payload.benefit
  },
  setUsedFrag(state, payload) {
    state.hasUsed = payload.value
  },
  clearBenefitDetial(state) {
    state.benefitDetil = null
  },
  onBenefitLoadingStart(state) {
    state.isBenefitsLoading = true
  },
  onBenefitLoadingFinished(state) {
    state.isBenefitsLoading = false
  }
}

export const actions: Actions = {
  async fetchBenefits({ commit }, payload) {
    commit('clearBenefits', {})
    commit('onBenefitLoadingStart', {})
    const { response, error } = await this.$api.fetchBenefits(payload)
    if (response) {
      commit('setBenefits', response)
      await this.$delay(500)
      commit('onBenefitLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onBenefitLoadingFinished', {})
  },
  async fetchBenefitDetail({ commit }, payload) {
    commit('clearBenefitDetial', {})
    commit('onBenefitLoadingStart', {})
    const { response, error } = await this.$api.fetchBenefitsDetail(payload)
    if (response) {
      commit('setBenefitDetail', response)
      await this.$delay(500)
      commit('onBenefitLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onBenefitLoadingFinished', {})
  },
  async setUsedFrag({ commit }, payload) {
    commit('setUsedFrag', { value: payload.hasUsed })
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
